var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      ref: "fluidpayContainer",
      attrs: { id: "fluidpay-container" },
    }),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "fluidpay-first-name" } }, [
        _vm._v("First Name"),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localFirstName,
            expression: "localFirstName",
          },
        ],
        staticClass: "form-control fluidpay-input",
        attrs: {
          id: "fluidpay-first-name",
          type: "text",
          placeholder: "First Name",
        },
        domProps: { value: _vm.localFirstName },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.localFirstName = $event.target.value
          },
        },
      }),
    ]),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "fluidpay-last-name" } }, [
        _vm._v("Last Name"),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localLastName,
            expression: "localLastName",
          },
        ],
        staticClass: "form-control fluidpay-input",
        attrs: {
          id: "fluidpay-last-name",
          type: "text",
          placeholder: "Last Name",
        },
        domProps: { value: _vm.localLastName },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.localLastName = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }